<template>
	 <el-dialog
	   :title="title!=null?title:'提示'"
	   :visible.sync="showWrap"
	   :close-on-click-modal="false"
	   width="501px"
	   custom-class="dialog-style tips-dialog warning"
	   :append-to-body="true"
	   >
	   <div class="cont">
	     {{content}}
	   </div>
	   <span slot="footer" class="dialog-footer">
	     <el-button type="primary" plain class="button-sty" @click="reject()"><i class="el-icon-close el-icon"></i>取 消</el-button>
	     <el-button type="primary" @click="resolve()" class="button-sty"><i class="el-icon-check el-icon"></i>确 定</el-button>
	   </span>
	 </el-dialog>
</template>

<script>
  import {
    mixins
  } from './mixins'

  export default {
    // name: 'errorMsg',
    mixins: [mixins]
  }
</script>

<style>
</style>
